import { ref } from "vue";
import { defineStore } from "pinia";
import { usePeerState } from "./videoCallStateParts/peerState";
import { useCallState } from "./videoCallStateParts/callState";
import { useConnectionState } from "./videoCallStateParts/connectionState";

const createVideoCallState = (rtcId) => {
  // eslint-disable-next-line no-unused-vars

  return defineStore("videoCall-" + rtcId, () => {
    const rtcIdState = ref(rtcId);
    const snackbar = ref({
      show: false,
      msg: "",
    });

    return {
      rtcId: rtcIdState,
      ...useCallState(rtcId),
      ...usePeerState(rtcId),
      ...useConnectionState(rtcId),
      snackbar,
    };
  });
};

export function useVideoCallState(rtcId) {
  if (!rtcId) {
    return null;
  }
  return createVideoCallState(rtcId)();
}
